import { css } from '@emotion/react';
import { COLORS3, MEDIA_QUERY, ZINDEX } from '@zola/zola-ui/src/styles/emotion';

export const screenOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${COLORS3.BLACK_100};
  z-index: ${ZINDEX.top};
  animation: fadeIn 0.5s ease forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.4;
    }
  }
`;

export const animation = css`
  bottom: -200px;
  animation: bounceIn 0.5s ease 1s forwards; // Animation name, duration, timing-function, delay & fill-mode

  ${MEDIA_QUERY.MOBILE} {
    bottom: -200px; // This is necessary to override the mobile styling in introVideo
    animation: bounceInMobile 0.5s ease 1s forwards;
  }

  @keyframes bounceIn {
    20% {
      bottom: 48px;
    }
    40% {
      bottom: 12px;
    }
    60% {
      bottom: 32px;
    }
    80% {
      bottom: 20px;
    }
    100% {
      bottom: 24px;
    }
  }

  @keyframes bounceInMobile {
    20% {
      bottom: 32px;
    }
    40% {
      bottom: -4px;
    }
    60% {
      bottom: 16px;
    }
    80% {
      bottom: 4px;
    }
    100% {
      bottom: 8px;
    }
  }
`;

export const introVideo = css`
  position: fixed;
  width: 104px !important;
  height: 184px !important;
  right: 24px;
  bottom: 24px;
  border-radius: 8px;
  background-color: ${COLORS3.WHITE_100};
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  z-index: ${ZINDEX.top};
  transition: all 0.25s;

  ${MEDIA_QUERY.MOBILE} {
    right: 8px;
    bottom: 8px;
  }
`;

export const large = css`
  transform: scale(2) translate(-28px, -48px);
  -webkit-filter: blur(0);
`;

export const frame = css`
  display: block;
  border-radius: 10px;
`;

export const overlay = css`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  border: 4px solid ${COLORS3.WHITE_100};
  cursor: pointer;
`;

export const button = css`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  border: none;
  background-color: ${COLORS3.BLACK_100};
  cursor: pointer;

  ${MEDIA_QUERY.MOBILE} {
    top: -4px;
    right: -4px;
  }
`;

export const restartButton = css`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

export const restartIcon = css`
  transform: rotate(-90deg);
`;

export const playButton = css`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background-color: rgba(14, 14, 14, 0.5); // #0E0E0E 50%
`;
